import { Component, OnInit } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { firstValueFrom } from 'rxjs';
import AppLauncherElectron from 'src/app/plugins/app-launcher.plugin';
import { isElectron } from 'src/app/shared/utils/platform.utils';
import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { DesktopLocationQrComponent } from '../desktop-location-qr/desktop-location-qr.component';

@Component({
    selector: 'app-location-alert',
    templateUrl: './location-alert.component.html',
    styleUrls: ['./location-alert.component.scss'],
    standalone: false
})
export class LocationAlertComponent implements OnInit {

  isElectron = isElectron();

  constructor(
    private sopoDialogRef: SopoDialogRef,
    private sopoPopupService: SopoPopupService,
    private iab: InAppBrowser,
  ) { }

  ngOnInit() {}

  openAppBrowser(url: string):void {
    if (isElectron()) AppLauncherElectron.openUrl({ url });
    else this.iab.create(url, '_system');
  }

  async recheck() {
    this.sopoDialogRef.close();
    const qrDialogRef = this.sopoPopupService.openDialog('app', DesktopLocationQrComponent, {
        closeButton: true,
        zIndex: 2001,
        backdropDismiss: false,
    });
    if (!qrDialogRef) return;

    const result = await firstValueFrom(qrDialogRef.afterClosed);
    if (result !== true) {
        this.sopoPopupService.openDialog('app', LocationAlertComponent, {
            closeButton: true,
            zIndex: 2001,
        });
    }
  }

  close() {
    this.sopoDialogRef.close();
  }

}
